module.exports = __webpack_public_path__ + "img/2012-12-14 20.13.45.2a260536.jpg";